import styled from 'styled-components';
import { breakpoints } from '../../styles/variables';
import { PanelFooter } from '../panel';

const DownloadOptionsBar = styled(PanelFooter)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;

  @media (max-width: ${breakpoints.TABLET_SIZE}) {
    flex-direction: column;
  }
`;

export default DownloadOptionsBar;
